import React from 'react';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';

type Props = {
  onClose: () => void;
  src?: string;
  title?: string;
};

/**
 * Show an image in a viewer.
 */
const ImageViewer = (props: Props) => {
  const { src, title, onClose } = props;
  return <Lightbox image={src} title={title} onClose={onClose} />;
};

export default ImageViewer;
